const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "9%"
  },
  {
    key: "avgMotorWindingTemp",
    zh: "平均电机绕组温度(℃)",
    en: "Average Motor Winding Temperature(℃)",
    width: "16%",
    tooltip: true
  },
  {
    key: "maxMotorWindingTemp",
    zh: "最大电机绕组温度(℃)",
    en: "Maximum Motor Winding Temperature(℃)",
    width: "16%",
    tooltip: true
  },
  {
    key: "avgEnvTemp",
    zh: "平均环境温度(℃)",
    en: "Average Environment Temperature(℃)",
    width: "14%",
    tooltip: true
  },
  {
    key: "maxEnvTemp",
    zh: "最大环境温度(℃)",
    en: "Maximum Environment Temperature(℃)",
    width: "15%",
    tooltip: true
  }
]

export default columns